import React from 'react';
import ContentLoader from 'react-content-loader';
import { useMount } from 'react-use';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

import { MicroSkillFetcherProps } from './types';

const renderCellLoader = (cell: any) => (
  <Stack
    key={cell.key}
    className={cn(cell.props.className, '!min-h-[5.6rem]')}
    style={cell.props.style}>
    <ContentLoader
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      height={14}
      speed={2}
      viewBox="0 0 100 14"
      width={100}>
      <rect height="14" rx="6" ry="6" width="100" x="0" y="0" />
    </ContentLoader>
  </Stack>
);

const MicroSkillFetcher = (props: MicroSkillFetcherProps) => {
  const { fetch, cells, rowData } = props;

  useMount(() => {
    if (rowData?.type === 'LAZY_LOAD') {
      fetch?.({ id: rowData.parentMicroSkillId });
    }
  });

  return <>{cells.map(renderCellLoader)}</>;
};

export default MicroSkillFetcher;
